// Framework and third-party non-ui
import React, { useState, useContext, useEffect } from 'react';
import { MapContext } from 'contexts/MapContext';

// Third-party components (buttons, icons, etc.)
import { makeStyles } from '@material-ui/core/styles';

// App components
import Any from '../Any';
import TrailLengthSlider from './TrailLengthSlider';

const TrailLength = () => {
  const [selected, setSelected] = useState(false);
  const [rangeVals, setRangeVals] = useState([]);
  const { advancedOptions, setAdvancedOptions } = useContext(MapContext);

  const useStyles = makeStyles((theme) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '400px',
    },
    groupTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '10px 10px',
    },
    options: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: '10px 10px',
      gap: '10px',
    },
    optionTitle: {
      fontFamily: 'Open Sans',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '.25px',
      color: '#222222',
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    setRangeVals(advancedOptions['Length'] ? advancedOptions['Length'] : [0, 20]);
  }, [advancedOptions]);

  const selectedHandler = () => {
    //force rerender irregardless of whether selected is null or false
    //so that all OptionAttribute child component clicked states are set to falsey value
    if (selected === null) {
      setSelected(false);
    } else {
      setSelected(null);
    }
    let newAdvancedOptions = { ...advancedOptions };
    delete newAdvancedOptions['Length'];
    setAdvancedOptions(newAdvancedOptions);
    setRangeVals([0, 20]);
  };

  return (
    <div className={classes.container}>
      <div className={classes.groupTitle}>
        <div className={classes.optionTitle}>Length</div>
        <Any selectedHandler={selectedHandler} selected={selected} />
      </div>
      <TrailLengthSlider
        selectedHandler={selectedHandler}
        advancedOptions={advancedOptions}
        setAdvancedOptions={setAdvancedOptions}
        rangeVals={rangeVals}
        setRangeVals={setRangeVals}
      />
    </div>
  );
};

export default TrailLength;
